import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loginEpic } from './_epics/login.epic';
import { logoutEpic } from './_epics/logout.epic';
import { logoutAuthEventEpic } from './_epics/logoutAuthEvent.epic';
import { sessionLostEpic } from './_epics/sessionLost.epic';

export const authEpic = safeCombineEpics(
  loginEpic,
  logoutEpic,
  logoutAuthEventEpic,
  sessionLostEpic,
);
